const signUpReducer = (state = {}, action) => {
    switch (action.type) {
      case "SIGN_UP": {
        return{
          ...state,
          signUpSuccess: action.success
        }
      }
      case "SIGN_UP_ERR": {
        return{
          ...state,
          signUpError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default signUpReducer;
  